import { call, put, takeEvery, select } from "redux-saga/effects"
import { DLogin } from "apis/DLogin"
import { callApi } from "sagas/Api"
import { PUT_NOTICE_AGREEMENT, setSuccess } from "actions"
import { putNoticeAgreement } from "apis/NoticeAgreement"
import { moveToTop } from "locale"

export function* handlePutNoticeAgreement() {
  yield takeEvery(PUT_NOTICE_AGREEMENT, execPutNoticeAgreement)
}

export const getNoticeAgreementSelecter = (state) => state.noticeAgreement
export function* execPutNoticeAgreement() {
  const noticeAgreement = JSON.parse(
    JSON.stringify(yield select(getNoticeAgreementSelecter))
  )
  for (const key in noticeAgreement) {
    // eslint-disable-next-line security/detect-object-injection
    noticeAgreement[key] = Number(!Boolean(noticeAgreement[key]))
  }
  const { payload, error } = yield call(
    callApi,
    putNoticeAgreement,
    noticeAgreement
  )

  if (payload && !error) {
    yield put(setSuccess(payload))
  } else {
    if (error.message === "invalid token") {
      // リフレッシュトークンが無効な場合
      yield call(DLogin, { prompt: true })
    } else if (error.message === "dauth error") {
      // サーバエラーなどでトークンリフレッシュに失敗した場合
      yield call(moveToTop)
    } else {
      // APIの処理に失敗した場合
      yield call(moveToTop)
    }
  }
}
